/* dch-app.js — interactivity for the D'Creme home page */
(function(){
  function all(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s));}
  function one(s,r){return (r||document).querySelector(s);}

  // Slideshows (hero, promo)
  all('[data-dch-slider]').forEach(function(sl){
    var track=one('[data-dch-track]',sl); if(!track)return;
    var n=all('[data-dch-slide]',track).length; var i=0;
    var dots=all('[data-dch-dot]',sl);
    function go(){ track.style.transform='translateX(-'+(i*100)+'%)';
      dots.forEach(function(d,di){ d.classList.toggle('is-active',di===i); }); }
    var p=one('[data-dch-prev]',sl), nx=one('[data-dch-next]',sl);
    if(p)p.addEventListener('click',function(){i=(i-1+n)%n;go();});
    if(nx)nx.addEventListener('click',function(){i=(i+1)%n;go();});
    dots.forEach(function(d,di){ d.addEventListener('click',function(){i=di;go();}); });
    go();
  });

  // Horizontal scrollers (products, concerns, social, reviews, ugc)
  all('[data-dch-scroller]').forEach(function(sc){
    var row=one('[data-dch-scrollrow]',sc); if(!row)return;
    var step=parseInt(sc.getAttribute('data-dch-step'),10)||320;
    var p=one('[data-dch-sprev]',sc), nx=one('[data-dch-snext]',sc);
    if(p)p.addEventListener('click',function(){row.scrollBy({left:-step,behavior:'smooth'});});
    if(nx)nx.addEventListener('click',function(){row.scrollBy({left:step,behavior:'smooth'});});
  });

  // Ingredient spotlight
  all('[data-dch-spotlight]').forEach(function(sp){
    var dots=all('[data-dch-spotdot]',sp);
    dots.forEach(function(d){
      d.addEventListener('click',function(){
        var idx=d.getAttribute('data-dch-spotdot');
        all('[data-dch-spotdot]',sp).forEach(function(x){x.classList.toggle('is-active',x.getAttribute('data-dch-spotdot')===idx);});
        all('[data-dch-spotpanel]',sp).forEach(function(pn){pn.style.display=(pn.getAttribute('data-dch-spotpanel')===idx)?'':'none';});
      });
    });
  });
})();
